/**
 * Main Admin Interface
 *
 * React-based admin interface with routing for Tab Manager.
 *
 * @since 1.0.0
 */

import { createRoot } from 'react-dom/client';
import { Router } from 'wouter';
import { useHashLocation } from 'wouter/use-hash-location';

import { NotificationsContainer, TabManagerApp } from './components';
import { NotificationProvider } from './contexts';

/**
 * Initialize the admin interface
 *
 * @since 1.0.0
 */
const initializeAdmin = (): void => {
  const container = document.getElementById('redfox-tab-manager-root');

  if (!container) {
    return;
  }

  const root = createRoot(container);

  root.render(
    <NotificationProvider>
      <Router hook={useHashLocation}>
        <TabManagerApp />
      </Router>
      <NotificationsContainer />
    </NotificationProvider>
  );
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAdmin);
} else {
  initializeAdmin();
}
